import { render, staticRenderFns } from "./AiTutor.vue?vue&type=template&id=11903dc7"
import script from "./AiTutor.vue?vue&type=script&lang=js"
export * from "./AiTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports